import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
// import coolgrey from 'sushiweb/tokens/color/grey';
import white from 'sushiweb/tokens/color/white';

export const DetailsContainer = styled.div`
  width: 100%;
  height: 124px;
  background: ${white};
  border-radius: 20px;
  border: 1px solid var(--coolgreycoolgrey-100, #f2f4f7);
  background: var(--basewhite-000, #fff);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
  overflow: hidden;
  p {
    color: var(--coolgreycoolgrey-800, #414a5d);
    font-size: 15px;
    font-weight: 300;
    margin-bottom: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    justify-content: space-between;
  }
  h6 {
    font-size: ${props => (props?.text?.length > 15 ? '2.0rem' : '2.6rem')};
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: Lexend-400;
    font-weight: 400;
  }
  span {
    color: var(--coolgreycoolgrey-800, #414a5d);
    font-size: 17px;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 5px;
    margin-top: 5px;
  }
  &:hover {
    border-radius: 20px;
    border: 1px solid var(--coolgreycoolgrey-200, #e6e9ef);
    background: var(--basewhite-000, #fff);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.02);
  }
  .tooltipInfo {
    font-size: 1.6rem;
  }
`;

export const DetailsContainerForInvoice = styled.div`
  width: 100%;
  height: 164px;
  background: ${white};
  border-radius: 20px;
  border: 1px solid var(--coolgreycoolgrey-100, #f2f4f7);
  background: var(--basewhite-000, #fff);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
  overflow: hidden;
  p {
    color: var(--coolgreycoolgrey-800, #414a5d);
    font-size: 15px;
    font-weight: 300;
    margin-bottom: ${props => (props.showDiscount ? '20px' : '50px')};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    justify-content: space-between;
  }
  h6 {
    font-size: ${props => (props?.text?.length > 15 ? '2.0rem' : '2.6rem')};
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: Lexend-400;
    font-weight: 400;
  }
  span {
    color: var(--coolgreycoolgrey-800, #414a5d);
    font-size: 17px;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 5px;
    margin-top: 5px;
  }
  &:hover {
    border-radius: 20px;
    border: 1px solid var(--coolgreycoolgrey-200, #e6e9ef);
    background: var(--basewhite-000, #fff);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.02);
  }
  .tooltipInfo {
    font-size: 1.6rem;
  }
`;

export const DiscountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 180px;
`;

export const DiscountedAmountWrapper = styled.div`
  font-size: 20px;
  display: flex;
  color: ${grey.z700};
  text-decoration: line-through;
`;

export const DiscountedPercentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 10px;
`;

export const DiscountedPercentContainer = styled.div`
  z-index: 1;
  color: var(--color-base-white, #fff);
  margin-left: -67px;
  font-size: 18px;
  font-weight: 500;
`;
